export default "__VITE_ASSET__EIqBCYEl__"